import { render, staticRenderFns } from "./DiscountPlanEdit.vue?vue&type=template&id=53456e94&"
import script from "./DiscountPlanEdit.vue?vue&type=script&lang=js&"
export * from "./DiscountPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports